import React from 'react';

import {Helmet, useNavigate} from 'views/module';

import ClientScheduleDashboard from 'views/scenes/schedule/client/ClientScheduleDashboard';
import SCHEDULE_SOURCES from 'views/scenes/schedule/schedule_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomClientScheduleDashboardPage = () => {
  const scheduleReadFlag = useFlag(FLAGS.SCHEDULE_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (scheduleReadFlag.isLoading || scheduleReadFlag.isEnabled) return;

    navigate('/schedule/client', {replace: true});
  }, [scheduleReadFlag.isEnabled, scheduleReadFlag.isLoading, navigate]);

  if (scheduleReadFlag.isLoading || !scheduleReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Client Schedule (Loom)</title>
      </Helmet>
      <ClientScheduleDashboard
        scheduleSource={SCHEDULE_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomClientScheduleDashboardPage;
